// Composites the level-2 hall art (2ndLEvel.png — gothic red hall) with its
// separate foreground floor (2ndLEvel-ground.png) into one 640x448 canvas used
// as the hall backdrop. Slots + candles are defined on the theme; this only
// builds the picture. Returns null on any load failure (theme then falls back).

import { BG_WIDTH, BG_HEIGHT } from "./background";

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("image load failed: " + url));
    img.src = url;
  });
}

export async function processHallArt(hallUrl: string, floorUrl: string): Promise<HTMLCanvasElement | null> {
  try {
    const [hall, floor] = await Promise.all([loadImage(hallUrl), loadImage(floorUrl)]);
    const c = document.createElement("canvas");
    c.width = BG_WIDTH;
    c.height = BG_HEIGHT;
    const ctx = c.getContext("2d");
    if (!ctx) return null;
    ctx.imageSmoothingEnabled = true;
    ctx.drawImage(hall, 0, 0, BG_WIDTH, BG_HEIGHT); // back wall, staircase, balcony, glowing openings
    ctx.drawImage(floor, 0, 0, BG_WIDTH, BG_HEIGHT); // perspective wood floor in the foreground
    return c;
  } catch {
    return null;
  }
}
